import React, { Component } from 'react';
import { Branch } from './Branch.js';
import { Caret } from './Caret.js';

export class Area extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hide: true,
            noOfMembers: 0,
            noOfFulltimeUnemployed: 0,
            noOfAffected: 0,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.noOfMembers !== prevState.noOfMembers) {
            if (this.props.parentCallback) {
                this.props.parentCallback('noofmembers:' + this.state.noOfMembers);
            }
        }

        if (this.state.noOfAffected !== prevState.noOfAffected) {
            if (this.props.parentCallback) {
                this.props.parentCallback('noofaffected:' + this.state.noOfAffected);
            }
        }

        if (this.state.noOfFulltimeUnemployed !== prevState.noOfFulltimeUnemployed) {
            if (this.props.parentCallback) {
                this.props.parentCallback('noofunemployed:' + this.state.noOfFulltimeUnemployed);
            }
        }
    }

    getAreaData() {
        let period = this.props.period;

        if (period !== null) {
            period = period.split(":");
            let periodYear = period[0];
            let periodMonth = period[1];

            let baseUrl = window.location.origin;

            var fetchStr = baseUrl + '/api/statistic/department?type=area&departmentName={name}&year={year}&month={month}'.replace('{name}', this.props.areaname).replace('{year}', periodYear).replace('{month}', periodMonth);
            
            fetch(fetchStr).then(res => res.json()).then(
                (result) => {
                    this.setState({
                        noOfMembers: result.numberofmembers,
                        noOfFulltimeUnemployed: result.unemploymentnumber,
                        noOfAffected: result.affectednumber
                    });
                }
            );
        }
    }

    getBranchesToTbody(branches, type) {
        let tbodyArr = [];

        for (let i = 0; i < branches.length; i++) {
            let rowEven = i % 2;
            //tbodyArr.push(<div key={i + 2} className='row'><div className='col1'>{branches[i].branchname}</div><div className='col2'>{branches[i].description}</div><div className='col3'></div><div className='col4'></div><div className='col5'></div></div>);
            tbodyArr.push(<Branch key={i + 2} type={type} branchname={branches[i].branchname} description={branches[i].description} period={this.props.period} rowclass={rowEven} />);
            //tbodyArr.push(<tr key={i + 2}><td>{branches[i].branchname}</td><td>{branches[i].description}</td><td></td><td></td><td></td></tr>);
        }

        return tbodyArr;
    }

    componentDidMount() {
        this.getAreaData();
    }

    calculatePercentage(members, unemployed) {
        if (unemployed === "0" || members === "0") {
            return "0";
        }

        return parseFloat((((unemployed - members) / members) * 100) + 100).toFixed(2).replace(".", ",");
    }

    render() {
        const hideClasses = this.state.hide ? "areabranch-hide" : "areabranch-show";
        const classes = `row ${hideClasses}`;

        return (
            <div className='areabranch-container'>
                <div className={classes} onClick={() => { this.setState({ hide: !this.state.hide }); }} >
                    <Caret open={ this.state.hide } />
                    <div className='col1'>{this.props.areaname}</div>
                    <div className='col2'>{this.props.description}</div>
                    <div className='col3'>{this.state.noOfMembers}</div>
                    <div className='col4'>{this.state.noOfFulltimeUnemployed}</div>
                    <div className='col5'>{this.calculatePercentage(this.state.noOfMembers, this.state.noOfFulltimeUnemployed)}%</div>
                    <div className='col6'>{this.state.noOfAffected}</div>
                    <div className='col7'>{this.calculatePercentage(this.state.noOfMembers, this.state.noOfAffected)}%</div>
                </div>
                {this.getBranchesToTbody(this.props.branches, 'areabranch')}
            </div>
        );
    }
}